'use client';

import { UTMType } from '@/@types';
import React, { Dispatch, ReactNode, SetStateAction, useState } from 'react';

type LayoutContextType = { title?: ReactNode; searchNavbarVisible?: boolean; utm?: UTMType };

const LayoutContext = React.createContext<[LayoutContextType, Dispatch<SetStateAction<LayoutContextType>>]>([{ title: undefined }, () => {}]);

export const LayoutProvider: React.FC<React.PropsWithChildren & { utm?: UTMType }> = ({ children, utm }) => {
  const state = useState<LayoutContextType>({
    title: undefined,
    searchNavbarVisible: true,
    utm,
  });
  return <LayoutContext.Provider value={state}>{children}</LayoutContext.Provider>;
};

export const useLayout = () => {
  return React.useContext(LayoutContext);
};
